export const appconfig = {
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  HELLOSIGN_CLIENT_ID: process.env.REACT_APP_HELLOSIGN_CLIENT_ID,
  REMOVE_HOME: process.env.REACT_APP_REMOVE_HOME === 'true'
}